export default __webpack_public_path__ + "static/media/users.447902a8.svg";